import * as React from "react"
import type { IconProps } from "../types"

const StackMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 16 16"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={1.5}
          d="M5.4665 8.00004L1.6665 10.125L7.99984 13.6667L14.3332 10.125L10.5332 8.00004M5.4665 8.00004L1.6665 5.87504L7.99984 2.33337L14.3332 5.87504L10.5332 8.00004M5.4665 8.00004L7.99984 9.41671L10.5332 8.00004"
        />
      </svg>
    )
  }
)
StackMini.displayName = "StackMini"

export default StackMini
